// 发票记录管理
import {contractApi} from "@/axios";
//获取发票记录信息
export function getRecordPage(params,data){
    return contractApi({
        url:'/invoice-record/page',
        method:'post',
        data:data,
        params:params
    })
}
//删除发票信息
export function deleteRecord(params){
    return contractApi({
        url:'/invoice-record',
        method:'delete',
        params:params
    })
}
//添加发票信息
export function addRecord(data){
    return contractApi({
        url:'/invoice-record',
        method:'post',
        data:data
    })
}
//修改发票信息
export function editRecord(data){
    return contractApi({
        url:'/invoice-record',
        method:'put',
        data:data
    })
}
//发票审核
export function auditRecord(data){
    return contractApi({
        url:'/invoice-record/audit',
        method:'put',
        data:data
    })
}
//根据邮寄ID获取相关发票记录
export function getRecordsByMail(params) {
    return contractApi({
        url: '/invoice-record/get-invoice-records',
        method: 'get',
        params:params
    });
}
//下载发票记录附件（试剂清单）
export function downloadRecord(id) {
    return contractApi({
        url: '/invoice-record/attachment/' + id,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//取消退票
export function cancelRefund(params) {
    return contractApi({
        url: '/invoice-info/cancel_refund',
        method: 'put',
        params: params
    });
}